import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FooterModule } from '@shared/footer/footer.module';
import { HeaderModule } from '@shared/header/header.module';
import { DataLoaderModule } from '@shared/data-loader/data-loader.module';
import { BtnDirective } from './buttons/btn.directive';
import { SecondaryBtnDirective } from './buttons/secondary-btn.directive';
import { PrimaryBtnDirective } from './buttons/primary-btn.directive';
import { CheckboxModule } from './checkbox/checkbox.module';
import { FooterBtnDirective } from './buttons/footer-btn.directive';
import { HeaderBtnDirective } from './buttons/header-btn.directive';
import { TabsModule } from './tabs/tabs.module';
import { RotateModule } from './rotate/rotate.module';
import { NewLinePipe } from './pipes/new-line.pipe';
import { DateFormatModule } from './date-format/date-format.module';
import { PaginationModule } from './pagination/pagination.module';
import { FullPageLoaderModule } from './full-page-loader/full-page-loader.module';

@NgModule({
	declarations: [
		BtnDirective,
		PrimaryBtnDirective,
		SecondaryBtnDirective,
		FooterBtnDirective,
		HeaderBtnDirective,
		NewLinePipe
	],
	imports: [
		TranslateModule,
		CommonModule,
		NgbModule,
		FormsModule,
		ReactiveFormsModule,
		TabsModule,

		PaginationModule,
		CheckboxModule,
		HeaderModule,
		FooterModule,
		DataLoaderModule,
		TabsModule,
		RotateModule,
		DateFormatModule.forRoot(),
		FullPageLoaderModule.forRoot()
	],
	exports: [
		TranslateModule,
		CommonModule,
		NgbModule,
		FormsModule,
		ReactiveFormsModule,
		TabsModule,

		PaginationModule,
		CheckboxModule,
		HeaderModule,
		FooterModule,
		DataLoaderModule,
		DateFormatModule,

		PrimaryBtnDirective,
		SecondaryBtnDirective,
		FooterBtnDirective,
		HeaderBtnDirective,
		TabsModule,
		RotateModule,
		NewLinePipe,
		FullPageLoaderModule
	]
})
export class SharedModule { }
